import { useEffect, useState } from "react";
import { NFeEventoCadastroDto, NFeEventoDto } from "./NFe.Evento.Dto";
import { showToast } from "src/componentes";
import {
  NFeEventoEnviar,
  NFeEventoExcluir,
  NFeEventoFiltrar,
  NFeEventoIncluir,
} from "src/services/Fiscal.Service";
import { useSearchParams } from "react-router-dom";
import {
  MapearErrosServidor,
  MapearErrosServidorCampo,
} from "src/hook/Functions";

const NFeEventoCode = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<NFeEventoDto[]>([]);
  const [searchParams] = useSearchParams();
  const [modalShowPropriedades, setModalShowPropriedades] = useState(false);
  const [modalShowCadastro, setModalShowCadastro] = useState(false);
  const [evento, setEvento] = useState<NFeEventoDto>();

  const nfeId = Number(searchParams.get("nfeId") ?? 0);

  const onShowModalCadastro = (show: boolean) => setModalShowCadastro(show);
  const onReturnModalPropriedades = () => setModalShowPropriedades(false);

  useEffect(() => {
    const controller = new AbortController();
    const Load = async () => {
      setLoading(true);
      filtrar(nfeId).finally(() => setLoading(false));
    };
    Load();
    return () => {
      controller.abort();
    };
  }, []);

  const filtrar = async (nfeId: number) => {
    await NFeEventoFiltrar(nfeId)
      .then((response) => {
        if (response.data.success) {
          setData(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
        showToast({
          message: "Ocorreu erro ao buscar dados",
          title: "Erro",
          variant: "Danger",
        });
        return undefined;
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleClickPropriedades = (value: NFeEventoDto) => () => {
    setModalShowPropriedades(true);
    setEvento(value);
  };

  const onSendModalPropriedades = async (value: NFeEventoDto) => {
    onReturnModalPropriedades();
    setLoading(true);
    await NFeEventoEnviar(value.id)
      .then((response) => {
        if (response.data.success === true) {
          filtrar(nfeId);
          showToast({
            message: "Evento enviado com sucesso",
            title: "Sucesso",
            variant: "Success",
          });
        }
        MapearErrosServidor(response.data.notifications, showToast);
      })
      .catch((error) => {
        showToast({
          message: "Ocorreu erro ao consultar situação",
          title: "Erro",
          variant: "Danger",
        });
        return undefined;
      })
      .finally(() => setLoading(false));
  };

  const onDeleteModalPropriedades = async (value: NFeEventoDto) => {
    setLoading(true);
    await NFeEventoExcluir(value.id)
      .then((response) => {
        if (response.data.success === true) {
          filtrar(nfeId);
        }
        MapearErrosServidor(response.data.notifications, showToast);
      })
      .catch((error) => {
        console.log(error);
        showToast({
          message: "Ocorreu erro ao excluir NFCe",
          title: "Erro",
          variant: "Danger",
        });
        return undefined;
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onReloadModalPropriedades = async () => {
    setLoading(true);
    await filtrar(nfeId).finally(() => setLoading(false));
  };

  return {
    loading,
    data,
    modalShowPropriedades,
    onReturnModalPropriedades,
    evento,
    handleClickPropriedades,
    onSendModalPropriedades,
    onShowModalCadastro,
    modalShowCadastro,
    nfeId,
    onDeleteModalPropriedades,
    onReloadModalPropriedades,
  };
};

export default NFeEventoCode;
